import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import { RegionCode } from '../../types';

const CustomCaretButton = ({ header, content, region }) => {
  const [isClicked, setClicked] = useState(false);
  const { t } = useTranslation();
  const regionPpLink = t(`COMMON.PRIVACY_POLICY_${region}`);

  const onClick = () => {
    if (isClicked) {
      setClicked(false);
    } else {
      setClicked(true);
    }
  };

  return (
    <>
      {header}
      <Button
        style={{
          border: 'none',
          color: '#1890FF',
        }}
        size="small"
        icon={isClicked ? <CaretRightOutlined /> : <CaretDownOutlined />}
        onClick={onClick}
      />
      {isClicked
        ? (
          <>
            <br />
            <Trans
              key={content}
              i18nKey={content}
            >
              <a href="mailto:dpo@co3.io">dpo@co3.io</a>
              <a href={`https://${regionPpLink}`} target="_blank" rel="noreferrer">
                {{ regionPpLink }}
              </a>
            </Trans>
          </>
        )
        : <></>}
    </>
  );
};

CustomCaretButton.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  region: PropTypes.oneOf(Object.values(RegionCode)).isRequired,
};

export default CustomCaretButton;
